import React, { useState } from 'react';
import PropTypes from 'prop-types';

import SelectEventDropdown from '../SelectEventDropdown/SelectEventDropdown';
import AddTablesForm from '../AddTablesForm/AddTablesForm';

const SelectEventForm = ({ createChart, eventFacetList }) => {
  const [selectedEvent, setSelectedEvent] = useState(eventFacetList[0].value);
  const handleCreateChart = tables => createChart(selectedEvent, tables);
  const handleSelect = event => setSelectedEvent(event);

  return (
    <div className="seating-create-modal">
      <h1 className="h1">Welcome to Your Seating Chart!</h1>
      <p className="create__subtitle">
        We&apos;ll add you to the first table. Add some other tables to get started!
      </p>
      <div className="create__form">
        <SelectEventDropdown eventFacetList={eventFacetList} onSelect={handleSelect} />
        <AddTablesForm createChart={handleCreateChart} />
      </div>
    </div>
  );
};

SelectEventForm.propTypes = {
  createChart: PropTypes.func.isRequired,
  eventFacetList: PropTypes.arrayOf(PropTypes.shape({})),
};

export default SelectEventForm;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/ChartCreator/SelectEventForm/SelectEventForm.jsx